let currentStep = 1;
let currentStepEle = document.getElementById("step-1")
let answersArr = []


const getResult = () =>{
    console.log(answersArr)
    const spookyAnswers = answersArr.filter((item)=>{
        return item == "spooky"
    })
    const hocusAnswers = answersArr.filter((item)=>{
        return item == "hocus-pocus"
    })
    const HauntedAnswers = answersArr.filter((item)=>{
        return item == "haunted-house"
    })
    const questionsWrapper = document.getElementById("questions-wrapper");
    questionsWrapper.style.display = "none";
    const answerDiv = document.getElementById("answer-wrapper")
    answerDiv.style.display="";
    if(spookyAnswers > hocusAnswers && spookyAnswers> HauntedAnswers){
        document.getElementById("spooky-answer").style.display="";
    }
    if(hocusAnswers > spookyAnswers && hocusAnswers> HauntedAnswers){
        document.getElementById("hocus-pocus-answer").style.display="";
    }
    if(HauntedAnswers > spookyAnswers && HauntedAnswers> hocusAnswers){
        document.getElementById("haunted-house-answer").style.display="";
    }
}
document.addEventListener("click", (e)=>{
    console.log("clicking")
    if(e.target.closest(".quiz-answer")){
        console.log("wahoo")
        if(currentStep == 4){
            const answer = e.target.closest(".quiz-answer").dataset.answer;
            answersArr.push(answer);
            getResult()
        }else{
            console.log("hello123")
            const answer = e.target.closest(".quiz-answer").dataset.answer;
            answersArr.push(answer);
             currentStep += 1;
             const progressBar = document.getElementById("hw-progress-bar");
             progressBar.style.width = currentStep*25 + "%";
            const selector = "step-" + currentStep;
            let nextStepEle = document.getElementById(selector)
            currentStepEle.style.display = "none";
            nextStepEle.style.display = "";
            currentStepEle = nextStepEle;
        }
    }
})